module.exports = __webpack_public_path__ + "static/media/sarah.b94a7f40.jpg";